module.exports = __webpack_public_path__ + "img/Hero Image 4.95b99d80.jpeg";